
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2911',
  depVersions: {
  "customer-portal-app": "static-1.2911",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9851",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25950",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5787",
  "hs-test-utils": "static-1.8215",
  "hub-http": "static-1.6411",
  "hub-http-shared-msw-handlers": "static-1.10428",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18790",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11668",
  "I18n": "static-7.1648",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6648",
  "payment-link-components": "static-1.23963",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7286",
  "quartz-core": "static-1.6505",
  "quartz-i18n": "static-1.961",
  "react": "static-7.189",
  "react-colorpicker": "static-2.10404",
  "react-dlb": "static-1.83",
  "react-utils": "static-2.5475",
  "reselect": "static-3.8",
  "rich-text-lib": "static-1.20159",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18242",
  "ui-components-test-utils": "static-1.5805",
  "UIComponents": "static-3.8614",
  "foundations-assets": "static-1.5068",
  "foundations-components": "static-1.8298",
  "foundations-theming": "static-1.4633",
  "foundations-theming-specialty": "static-1.2349",
  "framer-motion": "static-1.75",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1261",
  "quartz-config": "static-1.1064",
  "quartz-routing": "static-1.716",
  "quick-fetch": "static-1.4052",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16896",
  "rpc-client-utils": "static-1.4852",
  "sanitize-text": "static-1.8339",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.58",
  "ui-addon-draggable": "static-3.4951",
  "ui-addon-react-router-dom": "static-1.9728",
  "usage-tracker": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-anonymous": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.5",
  "video-components-external": "static-1.11906",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3533",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3563",
  "quartz-webpack": "static-1.3510",
  "bend-plugin-quartz-routing": "static-1.364",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "customer-data-objects": "static-1.7874",
  "frontend-preferences-client": "static-1.8121",
  "laboratory-lib": "static-3.7345",
  "onboarding-scopes": "static-1.6651",
  "seat-types-lib": "static-1.446",
  "ui-addon-opt": "static-4.8554",
  "HeadJS": "static-2.779",
  "hs-test-utils-bend-plugin": "static-1.3326",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.215",
  "ts-schema": "static-1.4214",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8045",
  "content-media-capture": "static-1.5133",
  "cssUtils": "static-1.846",
  "customer-data-ui-utilities": "static-1.10019",
  "file-manager-components": "static-1.24189",
  "HubStyle": "static-2.11975",
  "knowledge-content-types": "static-1.8584",
  "PatternValidationJS": "static-1-add-latest-to-version-tag.2",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.491",
  "ui-addon-emoji-picker": "static-1.10079",
  "ui-addon-i18n": "static-1.11341",
  "ui-business-units-lib": "static-1.9272",
  "ui-shepherd-react": "static-3.10456",
  "video-data-lib": "static-1.35564",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4517",
  "commerce-tours-lib": "static-1.6455",
  "customer-data-properties": "static-1.52237",
  "getting-started-shared-tasks": "static-1.18983",
  "growth-onboarding-reliability": "static-1.5276",
  "onboarding-tours": "static-1.16959",
  "reference-resolvers-lite": "static-1.8291",
  "sales-checkout-service-client": "static-1.3743",
  "ui-addon-iframeable": "static-1.9269",
  "user-context": "static-1.5305",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.856",
  "hubspotter-http": "static-1.4785",
  "icons": "static-2.667",
  "mobile-manifest-mixins": "static-1.553",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.961",
  "quartz-head": "static-1.951",
  "quartz-test": "static-1.961",
  "quartz-tracking": "static-1.665",
  "trellis-components": "static-1.2333",
  "ui-fonts": "static-1.930",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.5",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9619",
  "data-token-picker": "static-1.16739",
  "FileManagerLib": "static-1.39829",
  "property-translator": "static-1.5588",
  "atom": "static-1.5270",
  "merchandise-lib": "static-1.269",
  "purchase-motions-components": "static-1.6195",
  "salesImages": "static-1.529",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5781",
  "react-create-root-preference": "static-1.48",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1209",
  "bend-plugin-foundations-components": "static-1.4567",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "trellis-assets": "static-1.2314",
  "bend-plugin-foundations-theming": "static-1.3116",
  "foundations-theming-base": "static-1.3618",
  "stylex": "static-1.37",
  "interframe": "static-3.4948",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1-session-replay-endpoint-migration.5",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.262",
  "chirp-fetch": "static-1.2080",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4671",
  "react-flip-move": "static-1.74",
  "apollo-link-hub-http": "static-2.4846",
  "content-media-composition-data-lib": "static-1.12937",
  "content-media-compositions": "static-2.16944",
  "idb-keyval": "static-1.47",
  "immer": "static-1.33",
  "immerable": "static-1.4341",
  "magpie-lib": "static-1.5686",
  "magpie-types": "static-1.5146",
  "media-bridge-lib": "static-1.19257",
  "bender-build-tools": "static-1.3316",
  "usage-tracker-public": "static-1-session-replay-endpoint-migration.5",
  "inbound-db-properties-service-client": "static-1.3979",
  "superstore": "static-1.4952",
  "feedback-loader": "static-1.29649",
  "ai-components-ui-library": "static-1.9447",
  "ui-addon-video-player": "static-1.8899",
  "ui-coaching-tips": "static-1.29102",
  "ContentUtils": "static-1.68931",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4619",
  "sassPrefix": "static-1.160",
  "react-dnd-compat": "static-1.4808",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1408",
  "copilot-toolkit": "static-1.11630",
  "avatar-components": "static-1.2691",
  "navigation-messaging": "static-1.7879",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8369",
  "commerce-products-lib": "static-1.10273",
  "crm-message-bus": "static-1.43538",
  "growth-data-modal": "static-1.5741",
  "hubspot-apollo-client": "static-1.5071",
  "onboarding-tours-client": "static-1.5173",
  "calling-global-api": "static-1.65165",
  "calling-internal-common": "static-1.31508",
  "calling-lifecycle-internal": "static-1.66547",
  "calling-lifecycle-messages": "static-1.58841",
  "conditional-properties-service-client": "static-1.3931",
  "crm-links": "static-1.6509",
  "crm-pipelines-api-client-types": "static-1.4272",
  "customer-data-objects-ui-components": "static-1.13226",
  "customer-data-properties-shared-msw-handlers": "static-1.9755",
  "customer-data-property-utils": "static-1.8290",
  "external-options-client-types": "static-1.4260",
  "formula-editor": "static-1.14594",
  "framework-data-schema-resolvers": "static-1.7088",
  "google-libphonenumber": "static-1.41",
  "hs-resources": "static-1.373",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4350",
  "meetings-icalendar-utils-lib": "static-1.824",
  "multi-currency-client-types": "static-1.3825",
  "object-builder-ui-client": "static-1.49379",
  "pipeline-validation-client-types": "static-1.4100",
  "property-value-citations": "static-1.2851",
  "pulse": "static-1.810",
  "smart-property-lib": "static-1.8080",
  "tiered-pricing": "static-1.1755",
  "topics-actions-lib": "static-1.346",
  "ui-addon-form-validation": "static-1.11183",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3255",
  "growth-onboarding-next-action-utils": "static-1.2483",
  "navigation-components": "static-1.18552",
  "onboarding-tours-utils": "static-1.1025",
  "ui-shepherd-tracker": "static-1.7837",
  "ui-universal-auth": "static-1.9207",
  "batch-promise": "static-1.1738",
  "getting-started-shared-tasks-store": "static-1.18101",
  "hubspotter-http-shared-msw-handlers": "static-1.10426",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.5",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1142",
  "tanstack-virtual": "static-1.33",
  "audio-components": "static-1.6198",
  "FileManagerCore": "static-1.39688",
  "FileManagerImages": "static-1.37340",
  "video-components": "static-1.13908",
  "foundations-components-legacy": "static-1.1323",
  "purchase-motions-api": "static-1.6198",
  "signup-constants": "static-1.19355",
  "signup-ui-url-generator": "static-2.8250",
  "reactive-lib": "static-1.915",
  "simple-logging-lib": "static-1.3242",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22289",
  "growth-onboarding-feedback-components": "static-1.6774",
  "cms-field-types": "static-1.5009",
  "content-icons-ui": "static-1.2282",
  "integrations-lib": "static-1.16767",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.686",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.969",
  "customer-data-tracking": "static-1.7078",
  "products-iframe-lib": "static-1.8390",
  "products-ui-components-shared-msw-handlers": "static-1.10810",
  "restore-request-side-panel-lib": "static-1.1391",
  "onboarding-data-sync-lib": "static-1.2298",
  "hubspot-apollo-cache": "static-1.530",
  "calling-error-reporting": "static-1.31515",
  "shared-worker-versioning": "static-1.11232",
  "calling-usage-tracker": "static-1.6733",
  "voice-sms-access-library": "static-1.1697",
  "conversations-skeleton-state": "static-1.7441",
  "location-customization-utils-lib": "static-1.9847",
  "bark-lib": "static-1.16685",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6081",
  "react-codemirror": "static-1.10830",
  "fdsr-migration-layer": "static-1.207",
  "framework-builder-read-service-client": "static-1.4140",
  "framework-data-schema-quick-fetch": "static-1.6993",
  "persist-promise": "static-1.3895",
  "event-emitter": "static-1.1143",
  "bend-plugin-pulse": "static-1.313",
  "fast-json-patch": "static-1.66",
  "data-agent-kit": "static-1.496",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10511",
  "fsm": "static-1.3925",
  "policy-lib": "static-1.6980",
  "react-tinymce": "static-1.55759",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10574",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54885",
  "tinymce-plugins": "static-1.57999",
  "tinymce-themes": "static-1.56855",
  "growth-onboarding-next-action-components": "static-1.2511",
  "user-context-client": "static-1.4744",
  "nest": "static-1.429",
  "unified-auth-core-lib": "static-1.1003",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4726",
  "video-embed": "static-1.36398",
  "social-insights-client-types": "static-1.22580",
  "flux-actions": "static-1.354",
  "integrations-error-boundary-lib": "static-1.14182",
  "integrations-tracking-lib": "static-1.5801",
  "native-integrations-shared-strings": "static-1.7971",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10559",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.721",
  "sales-views-client-types": "static-1.4451",
  "InboxConnectUtils": "static-4.15341",
  "meetings-connect-utils-lib": "static-1.7800",
  "calling-orchestration-schema": "static-1.36474",
  "crm-record-cards-service-types": "static-1.3718",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16136",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.107",
  "trellis-story-utils": "static-1.4700",
  "storybook-react": "static-1.36",
  "hub-http-contrib": "static-1.3234",
  "tinymce-data": "static-1.40970",
  "ui-addon-sales-email": "static-1.5406",
  "layout-dnd-components": "static-1.12810",
  "layout-dnd-utils": "static-1.11785",
  "ui-brand-identity-lib": "static-1.15997",
  "NamespacedHubStyle": "static-2.9184",
  "outpost": "static-1.4359",
  "universal-page-editor-lib": "static-1.3205",
  "adobe-sign-auth-lib": "static-1.245",
  "ads-unified-auth-lib": "static-1.749",
  "google-sheets-integration-lib": "static-1.812",
  "microsoft-drive-integration-lib": "static-1.917",
  "surveymonkey-integration-lib": "static-1.259",
  "slack-ui-library": "static-1.10592",
  "ContentData": "static-1.69006",
  "layout-data-lib": "static-1.10110",
  "advanced-menus-core": "static-1.15439",
  "advanced-menus-lib": "static-1.12333",
  "ExportDialog": "static-6.10573",
  "ui-memberships-settings-lib": "static-1.34583",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15438",
  "simple-menus-lib": "static-1.16955"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2911",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9851",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25950",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5787",
  "hs-test-utils": "/hs-test-utils/static-1.8215",
  "hub-http": "/hub-http/static-1.6411",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10428",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18790",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11668",
  "I18n": "/I18n/static-7.1648",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6648",
  "payment-link-components": "/payment-link-components/static-1.23963",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7286",
  "quartz-core": "/quartz-core/static-1.6505",
  "quartz-i18n": "/quartz-i18n/static-1.961",
  "react": "/react/static-7.189",
  "react-colorpicker": "/react-colorpicker/static-2.10404",
  "react-dlb": "/react-dlb/static-1.83",
  "react-utils": "/react-utils/static-2.5475",
  "reselect": "/reselect/static-3.8",
  "rich-text-lib": "/rich-text-lib/static-1.20159",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18242",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5805",
  "UIComponents": "/UIComponents/static-3.8614",
  "foundations-assets": "/foundations-assets/static-1.5068",
  "foundations-components": "/foundations-components/static-1.8298",
  "foundations-theming": "/foundations-theming/static-1.4633",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2349",
  "framer-motion": "/framer-motion/static-1.75",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1261",
  "quartz-config": "/quartz-config/static-1.1064",
  "quartz-routing": "/quartz-routing/static-1.716",
  "quick-fetch": "/quick-fetch/static-1.4052",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16896",
  "rpc-client-utils": "/rpc-client-utils/static-1.4852",
  "sanitize-text": "/sanitize-text/static-1.8339",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.58",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4951",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9728",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.5",
  "video-components-external": "/video-components-external/static-1.11906",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3533",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3563",
  "quartz-webpack": "/quartz-webpack/static-1.3510",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.364",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "customer-data-objects": "/customer-data-objects/static-1.7874",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8121",
  "laboratory-lib": "/laboratory-lib/static-3.7345",
  "onboarding-scopes": "/onboarding-scopes/static-1.6651",
  "seat-types-lib": "/seat-types-lib/static-1.446",
  "ui-addon-opt": "/ui-addon-opt/static-4.8554",
  "HeadJS": "/HeadJS/static-2.779",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3326",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.215",
  "ts-schema": "/ts-schema/static-1.4214",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8045",
  "content-media-capture": "/content-media-capture/static-1.5133",
  "cssUtils": "/cssUtils/static-1.846",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10019",
  "file-manager-components": "/file-manager-components/static-1.24189",
  "HubStyle": "/HubStyle/static-2.11975",
  "knowledge-content-types": "/knowledge-content-types/static-1.8584",
  "PatternValidationJS": "/PatternValidationJS/static-1-add-latest-to-version-tag.2",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10079",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11341",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9272",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10456",
  "video-data-lib": "/video-data-lib/static-1.35564",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4517",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6455",
  "customer-data-properties": "/customer-data-properties/static-1.52237",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18983",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5276",
  "onboarding-tours": "/onboarding-tours/static-1.16959",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8291",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9269",
  "user-context": "/user-context/static-1.5305",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.856",
  "hubspotter-http": "/hubspotter-http/static-1.4785",
  "icons": "/icons/static-2.667",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.553",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.961",
  "quartz-head": "/quartz-head/static-1.951",
  "quartz-test": "/quartz-test/static-1.961",
  "quartz-tracking": "/quartz-tracking/static-1.665",
  "trellis-components": "/trellis-components/static-1.2333",
  "ui-fonts": "/ui-fonts/static-1.930",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.5",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9619",
  "data-token-picker": "/data-token-picker/static-1.16739",
  "FileManagerLib": "/FileManagerLib/static-1.39829",
  "property-translator": "/property-translator/static-1.5588",
  "atom": "/atom/static-1.5270",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "purchase-motions-components": "/purchase-motions-components/static-1.6195",
  "salesImages": "/salesImages/static-1.529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5781",
  "react-create-root-preference": "/react-create-root-preference/static-1.48",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1209",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4567",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.2314",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3116",
  "foundations-theming-base": "/foundations-theming-base/static-1.3618",
  "stylex": "/stylex/static-1.37",
  "interframe": "/interframe/static-3.4948",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-session-replay-endpoint-migration.5",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.262",
  "chirp-fetch": "/chirp-fetch/static-1.2080",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4671",
  "react-flip-move": "/react-flip-move/static-1.74",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4846",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12937",
  "content-media-compositions": "/content-media-compositions/static-2.16944",
  "idb-keyval": "/idb-keyval/static-1.47",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4341",
  "magpie-lib": "/magpie-lib/static-1.5686",
  "magpie-types": "/magpie-types/static-1.5146",
  "media-bridge-lib": "/media-bridge-lib/static-1.19257",
  "bender-build-tools": "/bender-build-tools/static-1.3316",
  "usage-tracker-public": "/usage-tracker-public/static-1-session-replay-endpoint-migration.5",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3979",
  "superstore": "/superstore/static-1.4952",
  "feedback-loader": "/feedback-loader/static-1.29649",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9447",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8899",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29102",
  "ContentUtils": "/ContentUtils/static-1.68931",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4619",
  "sassPrefix": "/sassPrefix/static-1.160",
  "react-dnd-compat": "/react-dnd-compat/static-1.4808",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1408",
  "copilot-toolkit": "/copilot-toolkit/static-1.11630",
  "avatar-components": "/avatar-components/static-1.2691",
  "navigation-messaging": "/navigation-messaging/static-1.7879",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8369",
  "commerce-products-lib": "/commerce-products-lib/static-1.10273",
  "crm-message-bus": "/crm-message-bus/static-1.43538",
  "growth-data-modal": "/growth-data-modal/static-1.5741",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5071",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5173",
  "calling-global-api": "/calling-global-api/static-1.65165",
  "calling-internal-common": "/calling-internal-common/static-1.31508",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66547",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58841",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3931",
  "crm-links": "/crm-links/static-1.6509",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4272",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13226",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9755",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8290",
  "external-options-client-types": "/external-options-client-types/static-1.4260",
  "formula-editor": "/formula-editor/static-1.14594",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7088",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "hs-resources": "/hs-resources/static-1.373",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4350",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.824",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3825",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49379",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4100",
  "property-value-citations": "/property-value-citations/static-1.2851",
  "pulse": "/pulse/static-1.810",
  "smart-property-lib": "/smart-property-lib/static-1.8080",
  "tiered-pricing": "/tiered-pricing/static-1.1755",
  "topics-actions-lib": "/topics-actions-lib/static-1.346",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11183",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3255",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2483",
  "navigation-components": "/navigation-components/static-1.18552",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1025",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7837",
  "ui-universal-auth": "/ui-universal-auth/static-1.9207",
  "batch-promise": "/batch-promise/static-1.1738",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18101",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10426",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.5",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1142",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "audio-components": "/audio-components/static-1.6198",
  "FileManagerCore": "/FileManagerCore/static-1.39688",
  "FileManagerImages": "/FileManagerImages/static-1.37340",
  "video-components": "/video-components/static-1.13908",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1323",
  "purchase-motions-api": "/purchase-motions-api/static-1.6198",
  "signup-constants": "/signup-constants/static-1.19355",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8250",
  "reactive-lib": "/reactive-lib/static-1.915",
  "simple-logging-lib": "/simple-logging-lib/static-1.3242",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22289",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6774",
  "cms-field-types": "/cms-field-types/static-1.5009",
  "content-icons-ui": "/content-icons-ui/static-1.2282",
  "integrations-lib": "/integrations-lib/static-1.16767",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.686",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.969",
  "customer-data-tracking": "/customer-data-tracking/static-1.7078",
  "products-iframe-lib": "/products-iframe-lib/static-1.8390",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10810",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1391",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2298",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.530",
  "calling-error-reporting": "/calling-error-reporting/static-1.31515",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11232",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6733",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1697",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7441",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9847",
  "bark-lib": "/bark-lib/static-1.16685",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6081",
  "react-codemirror": "/react-codemirror/static-1.10830",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.207",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4140",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6993",
  "persist-promise": "/persist-promise/static-1.3895",
  "event-emitter": "/event-emitter/static-1.1143",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.313",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "data-agent-kit": "/data-agent-kit/static-1.496",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10511",
  "fsm": "/fsm/static-1.3925",
  "policy-lib": "/policy-lib/static-1.6980",
  "react-tinymce": "/react-tinymce/static-1.55759",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10574",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54885",
  "tinymce-plugins": "/tinymce-plugins/static-1.57999",
  "tinymce-themes": "/tinymce-themes/static-1.56855",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2511",
  "user-context-client": "/user-context-client/static-1.4744",
  "nest": "/nest/static-1.429",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1003",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4726",
  "video-embed": "/video-embed/static-1.36398",
  "social-insights-client-types": "/social-insights-client-types/static-1.22580",
  "flux-actions": "/flux-actions/static-1.354",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14182",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5801",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7971",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10559",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.721",
  "sales-views-client-types": "/sales-views-client-types/static-1.4451",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15341",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7800",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36474",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3718",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16136",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.107",
  "trellis-story-utils": "/trellis-story-utils/static-1.4700",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-contrib": "/hub-http-contrib/static-1.3234",
  "tinymce-data": "/tinymce-data/static-1.40970",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5406",
  "layout-dnd-components": "/layout-dnd-components/static-1.12810",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11785",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15997",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9184",
  "outpost": "/outpost/static-1.4359",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3205",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.245",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.749",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.812",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.917",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.259",
  "slack-ui-library": "/slack-ui-library/static-1.10592",
  "ContentData": "/ContentData/static-1.69006",
  "layout-data-lib": "/layout-data-lib/static-1.10110",
  "advanced-menus-core": "/advanced-menus-core/static-1.15439",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12333",
  "ExportDialog": "/ExportDialog/static-6.10573",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34583",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15438",
  "simple-menus-lib": "/simple-menus-lib/static-1.16955"
}
};
